export class HrPerLeaveRequestKey {
    private static readonly keyPrefix = 'hrPerLeaveRequest';
    public static listTitle = `${HrPerLeaveRequestKey.keyPrefix}.listTitle`;
    public static beginDate = `${HrPerLeaveRequestKey.keyPrefix}.beginDate`;
    public static endDate = `${HrPerLeaveRequestKey.keyPrefix}.endDate`;
    public static regNumber = `${HrPerLeaveRequestKey.keyPrefix}.regNumber`;
    public static personnelName = `${HrPerLeaveRequestKey.keyPrefix}.personnelName`;
    public static personnelSurname = `${HrPerLeaveRequestKey.keyPrefix}.personnelSurname`;
    public static managerName = `${HrPerLeaveRequestKey.keyPrefix}.managerName`;
    public static managerSurname = `${HrPerLeaveRequestKey.keyPrefix}.managerSurname`;
    public static hrmTypeUuid = `${HrPerLeaveRequestKey.keyPrefix}.hrmTypeUuid`;
    public static beginTime = `${HrPerLeaveRequestKey.keyPrefix}.beginTime`;
    public static endTime = `${HrPerLeaveRequestKey.keyPrefix}.endTime`;
    public static peopleId = `${HrPerLeaveRequestKey.keyPrefix}.peopleId`;
    public static managerId = `${HrPerLeaveRequestKey.keyPrefix}.managerId`;
    public static absentDay = `${HrPerLeaveRequestKey.keyPrefix}.absentDay`;
    public static absentTime = `${HrPerLeaveRequestKey.keyPrefix}.absentTime`;
    public static calendarDay = `${HrPerLeaveRequestKey.keyPrefix}.calendarDay`;
    public static state = `${HrPerLeaveRequestKey.keyPrefix}.state`;
    public static leaveReason = `${HrPerLeaveRequestKey.keyPrefix}.leaveReason`;
    public static projectId = `${HrPerLeaveRequestKey.keyPrefix}.projectId`;
    public static documentId = `${HrPerLeaveRequestKey.keyPrefix}.documentId`;
}
